<template>
  <v-app id="landing-page" :style="{ 'background-color': colorEBikeFondo }">
    <v-system-bar
      fixed
      dark
      window
      :color="colorEBikeBarraFormulario"
      style="-webkit-app-region: drag"
    >
      <v-btn
        icon
        @click.stop="setDrawer(!drawer)"
        :color="'white'"
        v-if="user"
        style="-webkit-app-region: no-drag"
      >
        <v-icon class="ml-1">mdi-menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-icon :color="'white'">mdi-bike</v-icon>

      <span v-bind:style="{ color: 'white' }"> eBike Compostela v4.7  </span>
      <v-spacer></v-spacer>
    
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            :color="'white'"
            style="-webkit-app-region: no-drag"
            @click="_logout"
            class="mr-4"
            v-on="on"
            >mdi-account</v-icon
          >
        </template>
        <span>Cerrar Sesión</span>
      </v-tooltip>

      <v-icon
        :color="'white'"
        style="-webkit-app-region: no-drag"
        @click="_minimizeWin"
        >mdi-minus</v-icon
      >

      <v-icon
        :color="'white'"
        style="-webkit-app-region: no-drag"
        @click="_closeWin"
        >mdi-close</v-icon
      >
    </v-system-bar>

    <menu-drawer v-if="drawer" />

    <v-main class="#212226 mx-4 mt-8">
        <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MenuDrawer from "./components/MenuDrawer";
import ReservaFormulario from "./components/formularios/ReservaFormulario.vue";


export default {
  name: "App",
  //probando github

  components: {
    MenuDrawer,
    ReservaFormulario
  },

  data: () => ({
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeFondo",
      "colorEBikeBarraFormulario",
      "colorEBikeAccent1",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
     
  },

  mounted() {
    this.setDark(false);
    this.$router.push("/login");
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setDark", "setDrawer"]),
   
  
    _closeWin() {
      window.close();
    },

    _minimizeWin() {
      const { remote } = require("electron");
      remote.getCurrentWindow().minimize();
    },

    _changeDark() {
      this.setDark(!this.dark);
    },

    _maximizeWin() {
      const { remote } = require("electron");
      if (remote.getCurrentWindow().isMaximized) {
        window.resizeTo(800, 600);
      } else {
        remote.getCurrentWindow().maximize();
      }
    },

    async _logout() {
      this.setDrawer(false);
      await this.logOut([this.access_token]);
      this.$router.push("/login");
    },
  },
};

//background-image: url("./assets/fondo12.jpg");
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans:400,600,300");

@font-face {
  font-family: "Noto";
  src: local("Noto"),
    url(./fonts/noto-sans-v26-latin-regular.ttf) format("truetype");
}

* {
  text-transform: none !important;
}

#landing-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  font-family: 'Noto';
  
}

html {
  overflow: auto !important;
}

.v-data-table-header {
  background-color: grey;
}
</style>